/* <localization-form> — submit the country / language form on change (button stays for no-JS) */
if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      if (!form) return;
      this.querySelector('[data-localization-submit]')?.setAttribute('hidden', '');
      form.addEventListener('change', (e) => {
        if (!e.target.matches('select')) return;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  });
}
